module.exports = __webpack_public_path__ + "static/media/logo-hipercard.688ff29f.svg";